import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAttributes } from '@hozana/dom/hooks/useAttributes'
import { QA } from '@hozana/tests/constants'

import { BorderedSpan } from 'elements/layout/BorderedSpan'
import { Icon } from 'elements/media/Icon'
import { Ellipsis } from 'elements/text/Ellipsis'

import { ICON } from 'config/icons'

import { useMyIntention } from 'modules/intention/hooks/useMyIntention'

export const IntentionPrayersListButton: TFC = () => {
  const { t } = useTranslation()
  const attrs = useAttributes() // used for accessibility to pass "tabindex = -1" to avoid focus

  const { prayers, prayersCount } = useMyIntention() || {}

  // array from names and translate anomynous names
  const names = prayers?.map((prayer) => prayer.userName || t('intention:intention.anonymous-praying'))

  return (
    <BorderedSpan
      borderRadius="20px"
      bg={prayersCount > 0 ? 'whiteOrange' : 'transparent'}
      p="4px 10px 4px 5px"
      maxW="100%"
      data-testid={QA.INTENTION.PRAYER_LIST_LINK}
      {...attrs}
    >
      <Ellipsis color="yellow" fontSize="0.9em">
        <Icon name={ICON.FIRE} color="yellow" m="0 2px 0 0" size="1.4em" />({prayersCount})&nbsp;
        {prayersCount > 0 && names?.join(', ')}
      </Ellipsis>
    </BorderedSpan>
  )
}
